import classNames from "classnames";

import {Loader} from "@/components/placeholder/Loader";

interface TableLoadingStateProps {
  text?: string;
  className?: string;
  colSpan?: number;
}

export const TableLoadingState = ({text = "Loading…", className, colSpan}: TableLoadingStateProps) => (
  <tr>
    <td colSpan={colSpan} className={classNames("text-center py-5", className)}>
      <Loader text={text} />
    </td>
  </tr>
);
